import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getEmployeePermissions = async (token, params) => {
  const url = `employees/${params.id}/permissions`

  const data = await apiGet({ url, token, params })
  return data
}

export function useEmployeePermissions({ params, options }) {
  const token = useContext(AuthContext)
  const queryFn = () => getEmployeePermissions(token, params)
  const queryKey = ['employees-permissions', params]

  return useQuery(queryKey, queryFn, {
    ...options
  })
}
